import { BaseApiService } from '@/shared/api/services/base.service';
import type { ProjectGoalsGuide } from '@/types/project';

interface GoalsGuideResponse {
  data: {
    type: string;
    id: string;
    attributes: ProjectGoalsGuide;
  };
}

/**
 * Localized copy for the "Situation and goals" screen. Single source of truth
 * lives on the API (GET /v1/content/project-goals-guide); the client renders it
 * as-is. Locale is negotiated via the Accept-Language header the api client
 * attaches automatically.
 */
class GoalsGuideService extends BaseApiService {
  async get(): Promise<ProjectGoalsGuide> {
    const response = await this.httpGet<GoalsGuideResponse>(
      '/v1/content/project-goals-guide'
    );
    return response.data.attributes;
  }
}

export const goalsGuideService = new GoalsGuideService();
